import Box from '@mui/material/Box';
import { useState } from 'react';
import { VegaTable } from '../../common';
import Vega_Text from '../../common/v3/Vega_Text';
import { SECOND_AND_FOURTH_SAT_HOLIDAYS_MOCK_DATA } from './SecondAndFourthSatHolidaysMockData';

const ListOfSecondAndFourthSatHolidays = () => {
  const [holidays, setHolidays] = useState<any>(
    SECOND_AND_FOURTH_SAT_HOLIDAYS_MOCK_DATA
  );

  const columnRef = [
    {
      field: 'name',
      headerName: '  Holiday',
      flex: 0.5,
    },
    {
      field: 'date',
      headerName: '  Date',
      flex: 0.6,
    },
    {
      field: 'description',
      headerName: '  States',
      flex: 0.6,
    },
  ];

  return (
    <>
      <Box sx={{ pt: 3, marginLeft: 3 }}>
        <Vega_Text text="Second and Fourth Saturdays" fontWeight={500} mb={2} />
      </Box>
      <VegaTable
        noTopRadius
        data={holidays}
        columnDef={columnRef}
        idColumn={'id'}
        pageSize={5}
      />
    </>
  );
};

export default ListOfSecondAndFourthSatHolidays;
